import { render, staticRenderFns } from "./CategoryItem.vue?vue&type=template&id=bee3dafc"
import script from "./CategoryItem.vue?vue&type=script&lang=js"
export * from "./CategoryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyaboktober/65379/65/Stoffe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bee3dafc')) {
      api.createRecord('bee3dafc', component.options)
    } else {
      api.reload('bee3dafc', component.options)
    }
    module.hot.accept("./CategoryItem.vue?vue&type=template&id=bee3dafc", function () {
      api.rerender('bee3dafc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/stoffe/CategoryItem.vue"
export default component.exports